<template>
  <div>
    <img src="@/assets/image/activity/ojk-page.jpg" class="page-img">
  </div>
</template>

<script>
export default {
  name: 'OJK',
}
</script>

<style scoped lang="stylus">
.page-img
  width 100%
  height 600px
</style>
